import * as React from "react";
import style from "./basicMenu.module.scss";
import { Menu, MenuButton, MenuList, MenuItem, Button } from "@chakra-ui/react";
import { Link } from "react-scroll"

export default function BasicMenu({ icon }) {
  return (
    <Menu>
      <MenuButton as={Button} className={style.menu}>
        {icon}
      </MenuButton>
      <MenuList className={style.menuList}>
        <MenuItem className={style.menuItem}>
          <Link
            className={style.link}
            to="home"
            spy={true}
            smooth={true}
            offset={50}
            duration={500}
          >
            HOME
          </Link>
        </MenuItem>
        <MenuItem className={style.menuItem}>
        <Link
            className={style.link}
            to="aboutMe"
            spy={true}
            smooth={true}
            offset={50}
            duration={500}
          >
            SOBRE MÍ
          </Link>
        </MenuItem>
        <MenuItem className={style.menuItem}>
        <Link
            className={style.link}
            to="projects"
            spy={true}
            smooth={true}
            offset={50}
            duration={500}
          >
            PROYECTOS
          </Link>
        </MenuItem>
        <MenuItem className={style.menuItem}>
        <Link
            className={style.link}
            to="contacto"
            spy={true}
            smooth={true}
            offset={50}
            duration={500}
          >
            CONTACTO
          </Link>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
